import { Flex, Spinner, Text } from '@servicetitan/anvil2';

/**
 * Component to display a loading spinner with optional message
 */
export interface LoadingScreenProps {
    message?: string;
}

export const LoadingScreen = ({ message = 'Loading...' }: LoadingScreenProps) => {
    return (
        <Flex
            alignItems="center"
            direction="column"
            justifyContent="center"
            gap="2"
            style={{ width: '100%' }}
        >
            <Spinner style={{ width: '50px', margin: '25px' }} />
            <Text>{message}</Text>
        </Flex>
    );
};
